import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AuthServicesService } from 'src/app/services/auth-services.service';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-liste',
  templateUrl: './liste.component.html',
  styleUrls: ['./liste.component.scss']
})
export class ListeComponent implements OnInit {
  userData: any = {};
  imgUrl: Observable<any>;
  evenement: any = {};
  evenementId: string = '';
  evenements: any[] = [];
  userTempsFort: unknown;
  dateDebut: string;
  dateFin: string;

  constructor(private app: AppComponent, private afs: FirebaseFunctionsService, private authService: AuthServicesService) {
    this.getUserData();
  }

  ngOnInit(): void {
    setTimeout(this.app.afficherPage,2000);
    this.getAllEvents();
  }
  getUserData(){
    const uid = sessionStorage.getItem('userId');
    if(uid!=null){
      this.afs.getUtilisateur(uid).forEach( user => {
        this.userData = user;
        this.afs.getProfilePicture(uid).subscribe( imgs => {
          this.afs.getImgUrlFromFireStorage(`/utilisateurs/${uid}/profilePicture/${imgs.items[0]['name']}`).subscribe( url => {
            this.imgUrl = (url);
          })
        });
      });
      this.afs.getUserStarTemps(uid).subscribe( temps => {
        this.userTempsFort = temps;
      });
    }else{
      this.go('/');
    }
  }
  getAllEvents(){
    this.evenements = [];
    this.afs.getAllEvents().forEach(events =>{
      events.forEach(evts => {
        this.afs.getUtilisateur(evts.data()['createdBy']).forEach( user => {
          const nom = user['nom'].toLowerCase();
          const prenom = user['prenom'];
          this.evenements.push({
            nom: evts.data()['name'],
            dateStart: new Date(evts.data()['dateStart'].seconds * 1000).toDateString(),
            dateEnd: new Date(evts.data()['dateEnd'].seconds * 1000).toDateString(),
            isActive: (evts.data()['isActive']).toString(),
            eventId: evts.data()['evenementId'],
            createdBy: `${nom.charAt(0).toUpperCase() + nom.slice(1).toLowerCase()}, ${prenom.charAt(0).toUpperCase() + prenom.slice(1).toLowerCase()}`
          });
        })
      });
    });
  }
  manageDropDown(): void {
    const dorpDownDiv = document.querySelector('.menu_dropdown') as HTMLElement;
    dorpDownDiv.style.display = (dorpDownDiv.style.display == 'block') ? 'none' : 'block';
  }
  manageModifyModal(eventId: string){
    const modifyModal = document.querySelector('.modifyModal_ctn') as HTMLElement;
    modifyModal.style.display = (modifyModal.style.display != 'flex') ? 'flex' : 'none';
    this.getEvent(eventId);
  }
  manageDeleteModal(eventId: string){
    const deleteModal = document.querySelector('.deleteModal_ctn') as HTMLElement;
    deleteModal.style.display = (deleteModal.style.display != 'flex' ? 'flex': 'none');
    this.evenementId = eventId;
  }
  closeDeleteModal(){
    const deleteModal = document.querySelector('.deleteModal_ctn') as HTMLElement;
    deleteModal.style.display = (deleteModal.style.display != 'flex' ? 'flex': 'none');
  }
  delete(){
    this.afs.getEventById(this.evenementId).subscribe(event => {
      if(event.data()['isActive'] === false){
        const today = new Date().toLocaleDateString();
        const dateDebut = new Date(event.data()['dateStart'].toDate()).toLocaleDateString();
        if(dateDebut > today){
          this.afs.deleteEvent(this.evenementId).then(res => {
            if(res== true){
              this.app.showMessage(1, `L' évènement ${event.data()['name']} a été supprimer.`, 3000);
              this.getAllEvents();
              this.evenementId = '';
              this.closeDeleteModal();
            }else{
              this.app.showMessage(3, 'Nous n\'avons pas pu supprimer l\'évènement. Réessayez plus tard.',3000);
            }
          });
        }
      }else{
        this.app.showMessage(3, 'Vous ne pouvez pas supprimer un évènemen en cours.', 3000);
      }
    });
  }
  closeModifyModal(){
    const modifyModal = document.querySelector('.modifyModal_ctn') as HTMLElement;
    modifyModal.style.display = 'none';
  }
  getEvent(eventId: string){
    this.afs.getEventById(eventId).forEach(event => {
      this.evenement = event.data();
    });
  }
  validateEventDate(){
    const dateDebutDate = new Date(this.dateDebut + 'T00:00:00');
    const dateFinDate = new Date(this.dateFin + 'T00:00:00');
    const today = new Date();
    if(this.dateDebut == '' || this.dateFin == ''){
      this.afs.showMessage(3, 'Veuillez vous assurer d\'avoir entrer la date du début ou de la fin de l\'évènement.', 3000);
      return false;
    }else if( dateDebutDate >= dateFinDate ){
      this.afs.showMessage(3, 'La date de fin de l\'évènement doit être supérieur à la date de début d\'au moins 1 jour.', 5000);
      return false;
    }else if( dateDebutDate <= today){
      this.afs.showMessage(3, 'La date de début de l\'évènement doit être supérieur à aujourd\'hui', 3000);
      return false;
    }else{
      return true;
    }
  }
  modify(eventId: string){
    const debut = new Date(this.dateDebut + 'T00:00:00');
    const dateFinDate = new Date(this.dateFin + 'T00:00:00');
    if(this.validateEventDate () == true){
      this.afs.modifyEvents(eventId, debut,dateFinDate);
      this.evenements = [];
      this.getAllEvents();
      this.closeModifyModal();
    }
  }
  go(url:string){
    this.app.navigateTo(url);
  }
  signOut(){
    this.authService.signOut();
  }

}
